import axios from "axios";
import firebase from "../../firebase";
import { isJsonString } from "./helpers";

export const fetchThoughts = async () => {
  try {
    const res = await axios.get(
      "https://us-central1-thought-cabinet.cloudfunctions.net/app/getThoughts"
    );
    res.data.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    res.data.forEach((thought) => {
      for (const key in thought) {
        if (isJsonString(thought[key])) {
          thought[key] = JSON.parse(thought[key]);
        }
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching thoughts:", error);
  }
};

export const submitThought = async (thoughtData) => {
  const user = firebase.auth().currentUser;
  const token = user && (await user.getIdToken());

  const { type, content } = thoughtData;

  if (type === "link") {
    const formData = new FormData();
    const { url, title, description } = content.linkContent;
    const { imageFile, date } = content;

    formData.append("file", imageFile, imageFile.name);

    formData.append("caption", description);
    formData.append("url", url);
    formData.append("title", title);
    formData.append("type", type);
    formData.append("date", date);

    try {
      await axios.post(
        "https://us-central1-thought-cabinet.cloudfunctions.net/app/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error uploading link:", error.response.data);
    }
  } else if (type === "image" && content.imageFile) {
    const formData = new FormData();

    formData.append("file", content.imageFile, content.imageFile.name);
    formData.append("date", content.date);

    if (content.caption) {
      formData.append("caption", content.caption);
    }

    try {
      await axios
        .post(
          "https://us-central1-thought-cabinet.cloudfunctions.net/app/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          fetchThoughts();
          // rest form
          // setContent("");
          // setImageFile(null);
        });
    } catch (error) {
      console.error("Error uploading image:", error.response.data);
    }
  } else {
    try {
      const { date, caption, preview } = content;
      await axios
        .post(
          "https://us-central1-thought-cabinet.cloudfunctions.net/app/createThought",
          {
            date: date,
            type: type,
            content: caption,
            preview: preview,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          fetchThoughts();
          // setContent("");
          // setImageFile(null);
        });
    } catch (error) {
      console.error("Error adding thought:", error);
    }
  }
};

export const fetchThoughtsByDate = async (date) => {
  try {
    const res = await axios.post(
      "https://us-central1-thought-cabinet.cloudfunctions.net/app/getThoughtsByDate",
      { sunday: date }
    );
    res.data.sort((a, b) => new Date(b.date) - new Date(a.date));
    res.data.forEach((thought) => {
      for (const key in thought) {
        if (isJsonString(thought[key])) {
          thought[key] = JSON.parse(thought[key]);
        }
      }
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching thoughts by date:", error);
  }
};
